/** Session + dismissible nudge when MFA used a non-passkey method but passkeys are enrolled. */

const SESSION_KEY = 'mfa_portability_session';
const DISMISS_KEY = 'mfa_portability_nudge_dismissed_until';

export type MfaPortabilitySession = {
  hasPasskeyEnrolled: boolean;
  usedPasskey: boolean;
  method: string;
  at: number;
};

export function recordMfaCompletion(method: string, availableMethods: string[]): void {
  const methods = (availableMethods || []).map((m) => m.toLowerCase());
  const payload: MfaPortabilitySession = {
    hasPasskeyEnrolled: methods.includes('passkey'),
    usedPasskey: method.toLowerCase() === 'passkey',
    method: method.toLowerCase(),
    at: Date.now(),
  };
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function readMfaPortabilitySession(): MfaPortabilitySession | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as MfaPortabilitySession;
  } catch {
    return null;
  }
}

export function shouldShowPasskeyPortabilityNudge(): boolean {
  const session = readMfaPortabilitySession();
  if (!session?.hasPasskeyEnrolled || session.usedPasskey) return false;
  try {
    const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (until > Date.now()) return false;
  } catch {
    /* ignore */
  }
  return true;
}

/** Dismiss for 14 days (user can still add a passkey anytime from Account Settings). */
export function dismissPasskeyPortabilityNudge(days = 14): void {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
  } catch {
    /* ignore */
  }
}

export function clearMfaPortabilitySession(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}
